import {RichTextContent, RichTextContentDTO, RichTextContentParams} from "./rich-text.content";
import {MapContent, MapContentDTO, MapContentParams} from "./map.content";
import {BaseListContent} from "./list.abstract.content";
import {CMSContentType} from "../CMSType";
import {AContentDTO} from "../base.content";


export type DetailsItemsDTO = RichTextContentDTO | MapContentDTO
export interface DetailsDTO extends AContentDTO {
  items: Array<DetailsItemsDTO>;
}

export type DetailsContentChild = RichTextContent|MapContent;
export type DetailsParams = Array<DetailsContentChild>;

export class DetailsContent extends BaseListContent<DetailsContentChild> {
  constructor(data: DetailsParams = []) {
    super(CMSContentType.details, {items: data});
  }

  toParams(): DetailsParams {
    return this.items.toArray();
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/details.content.ts